import React, { TextareaHTMLAttributes } from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { Container, TextArea, Label, Legend, Counter } from './styles';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string | null;
  error?: string | null;
}

const TextAreaForm: React.FC<Props> = (props) => {
  const [length, setLength] = React.useState(0);

  const handle_change = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setLength(e.target.value.length);

    if (props.onChange) {
      props.onChange(e);
    }
  };

  return (
    <Container>
      <Label>
        {props.label}
        {props.required && <Legend>*</Legend>}
      </Label>
      <TextArea {...props} error={Boolean(props.error)} onChange={handle_change} />
      <Counter>
        {length}/{props.maxLength}
      </Counter>
      {props.error && (
        <Legend>
          <AiOutlineInfoCircle />
          {props.error}
        </Legend>
      )}
    </Container>
  );
};

export { TextAreaForm };
